import { createAction } from 'redux-starter-kit';

export const SET_FUNDS_AND_MPS_REF = 'setFundsAndMpsRef';

export const setFundsAndMpsRef = createAction(SET_FUNDS_AND_MPS_REF);

export const fundsAndMpsRefActions = {
  setFundsAndMpsRef
};
